import { render, staticRenderFns } from "./RealEstateForm.vue?vue&type=template&id=5b3c0d58&"
import script from "./RealEstateForm.vue?vue&type=script&lang=js&"
export * from "./RealEstateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports